import { axios } from "../../lib/axios";


export function getSignature({ topic, role, password }) {
    return axios.post(`session/create`, { topic, role: `${role}`, password })
}

export function isAndroidBrowser() {
    return /android/i.test(navigator.userAgent);
}

export async function toggleFullscreen() {
    const elem = document.getElementById("room");
    if (!elem) {
        throw new Error("Fullscreen video container was not found.");
    }

    const fullscreenElement = document.fullscreenElement
        || document.webkitFullscreenElement
        || document.msFullscreenElement;

    if (fullscreenElement) {
        const exitFullscreen = document.exitFullscreen
            || document.webkitExitFullscreen
            || document.msExitFullscreen;

        if (!exitFullscreen) {
            throw new Error("Exiting fullscreen is not supported by this browser.");
        }

        await exitFullscreen.call(document);
        return;
    }

    const requestFullscreen = elem.requestFullscreen
        || elem.webkitRequestFullscreen
        || elem.msRequestFullscreen;

    if (!requestFullscreen) {
        throw new Error("Fullscreen is not supported by this browser.");
    }

    await requestFullscreen.call(elem);
}


export function BindEvents(zmClient, stream) {
    // updated properties of user 
    zmClient.on('user-updated', (payload) => {
        //console.log(payload[0]?.userId, ' properties were updated')
    })

    // When a participant turns on or off their video
    zmClient.on('peer-video-state-change', (payload) => {
        const CanvasElem = document.querySelector(`#participant-canvas-${payload.userId}`)
        const AvatarElem = document.querySelector(`#participant-avatar-${payload.userId}`)
        if (payload.action === 'Start') {
            AvatarElem.style.display = "none";
            CanvasElem.style.display = "block";
            stream.renderVideo(CanvasElem, payload.userId, 300, 160, 0, 0, 2)
        } else if (payload.action === 'Stop') {
            AvatarElem.style.display = "flex";
            CanvasElem.style.display = "none";
            stream.stopRenderVideo(CanvasElem, payload.userId)
        }
    })

    zmClient.on('active-speaker', (payload) => {
        // console.log('Active speaker', payload)
    })

}
